import {IPagedResults, PagedResults} from './pagedResults';

export interface IPagedResultsFactory {
    create<T>(baseUrl: string, map?: (value) => T, parameters?: any, numberOfItemsPerPage?: number): IPagedResults<T>;
}

export class PagedResultsFactory implements IPagedResultsFactory {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService) {
    }

    create<T>(baseUrl: string, map?: (value) => T, parameters?: any, numberOfItemsPerPage?: number) : IPagedResults<T> {
        return new PagedResults<T>(this._$http, baseUrl, map, parameters, numberOfItemsPerPage);
    }
}

angular.module('deliveryCreate.app').service('PagedResultsFactory', PagedResultsFactory);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/paging/pagedResultsFactory.ts
 **/